
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PatientOtherDetails',
  data () {
    return {
      choices: [1,3],
      deceased: false,
    }
  }
})
